import * as yup from 'yup';
import {
  CARD_ADDRESS_INVALID,
  CARD_ADDRESS_REQUIRED,
  CARD_HOLDER_NAME_INVALID,
  CARD_HOLDER_NAME_REQUIRED,
  CARD_HOLDER_NAME_TOO_LONG,
  ZIP_CODE_REQUIRED,
  PHONE_INVALID,
  PHONE_REQUIRED,
  NICKNAME_TOO_LONG,
  CARD_NICKNAME_INVALID_ADD_CARD,
  BILLING_ADDRESS_TOO_LONG,
  ZIP_CODE_INVALID,
  RECAPTCHA_REQUIRED,
} from '../../constants/field-error-messages';
import {
  BILLING_ADDRESS_REGEX,
  NAME_ON_CARD_REGEX,
  NICKNAME_CARD_REGEX,
  NON_DIGITS_REGEX,
  ZIPCODE_REGEX,
  PHONE_REGEX,
} from '../../constants/regex';
import { ERR_ZIPCODE_FIND } from '../../constants/response-error-messages';

const commonRule = {
  cardNickName: yup
    .string()
    .max(40, NICKNAME_TOO_LONG.message)
    .matches(NICKNAME_CARD_REGEX, CARD_NICKNAME_INVALID_ADD_CARD.message),

  cardHolderName: yup
    .string()
    .trim()
    .required(CARD_HOLDER_NAME_REQUIRED.message)
    .max(100, CARD_HOLDER_NAME_TOO_LONG.message)
    .matches(NAME_ON_CARD_REGEX, {
      message: CARD_HOLDER_NAME_INVALID.message,
      excludeEmptyString: true,
    }),
  recaptcha: yup.string().nullable().required(RECAPTCHA_REQUIRED.message),
};

export const basicPaymentRule = {
  ...commonRule,
  isB2B: yup.boolean(),
  addressLine1: yup
    .string()
    .trim()
    .required(CARD_ADDRESS_REQUIRED.message)
    .matches(BILLING_ADDRESS_REGEX, {
      message: CARD_ADDRESS_INVALID.message,
    }),
  addressLine2: yup
    .string()
    .trim()
    .max(60, BILLING_ADDRESS_TOO_LONG.message)
    .matches(BILLING_ADDRESS_REGEX, {
      message: CARD_ADDRESS_INVALID.message,
    }),
  zipCode: yup
    .string()
    .when('isZipCodeNotFoundError', {
      is: true,
      then: yup.string().matches(NON_DIGITS_REGEX, {
        message: ZIP_CODE_INVALID.message,
      }),
    })
    .when('isZipCodeApiError', {
      is: true,
      then: yup.string().matches(NON_DIGITS_REGEX, {
        message: ERR_ZIPCODE_FIND.message,
      }),
    })
    .required(ZIP_CODE_REQUIRED.message)
    .matches(ZIPCODE_REGEX, { message: ZIP_CODE_INVALID.message }),
  isZipCodePending: yup.boolean(),
  isZipCodeApiError: yup.boolean(),
};

export const primaryPhoneRule = {
  primaryPhone: yup.object().when('isB2B', {
    is: false,
    then: yup.object().shape({
      number: yup
        .string()
        .required(PHONE_REQUIRED.message)
        .matches(PHONE_REGEX, PHONE_INVALID),
    }),
  }),
};

export const b2cPaymentRule = {
  ...commonRule,
  billingAddressID: yup
    .number()
    .nullable()
    .required(CARD_ADDRESS_REQUIRED.message),
};
